import { Component, inject } from '@angular/core';
import { formControl, Validators } from '@al00x/forms';
import {
  ButtonClickEvent,
  CacBaseDialogComponent,
  CacDialogLayoutComponent,
  CacFormBuilderComponent,
  formBuilder,
} from '@controladad/ng-base';
import { BlogCategoryCreate, BlogCategoryEntity, BlogCategoryUpdate } from '@repo/types';
import { BlogCategoryApiService } from '@/core';

export interface BlogCategoryDialogData {
  blogCategory?: BlogCategoryEntity;
}

export type BlogCategoryDialogResult = boolean;

@Component({
  selector: 'app-blog-category-dialog',
  imports: [CacDialogLayoutComponent, CacFormBuilderComponent],
  templateUrl: './blog-category-dialog.component.html',
  styleUrl: './blog-category-dialog.component.scss',
})
export class BlogCategoryDialogComponent extends CacBaseDialogComponent<
  BlogCategoryDialogData,
  BlogCategoryDialogResult
> {
  private readonly blogCategoryApi = inject(BlogCategoryApiService);

  form = formBuilder({
    cols: 1,
    inputs: {
      name: {
        control: formControl<string>(undefined, Validators.required),
        label: 'Title',
      },
    },
  });

  constructor() {
    super();
    const values = this.data?.blogCategory;
    if (values) {
      this.form.patchValue(values);
    }
  }

  onSubmit(e: ButtonClickEvent) {
    const values = this.form.getValue();

    if (!values) return;
    const request = this.data?.blogCategory
      ? this.blogCategoryApi.updateBlogCategory({
          name: { value: values.name },
          id: this.data.blogCategory.id,
        })
      : this.blogCategoryApi.create({ name: values.name });
    request.pipe(e.pipe()).subscribe(() => {
      this.submit(true);
    });
  }
}
